import { Modifier } from '@popperjs/core';

export class PopperUtils {
  static sameWidth: Modifier<'sameWidth', Record<string, never>> = {
    name: 'sameWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn({ state }) {
      state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect({ state }) {
      const reference = state.elements.reference as HTMLElement;
      const popper = state.elements.popper as HTMLElement;
      popper.style.width = `${reference.offsetWidth}px`;
      return () => {};
    }
  };

  static minWidth: Modifier<'minWidth', Record<string, never>> = {
    name: 'minWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn({ state }) {
      state.styles.popper.minWidth = `${state.rects.reference.width}px`;
    },
    effect({ state }) {
      const reference = state.elements.reference as HTMLElement;
      const popper = state.elements.popper as HTMLElement;
      popper.style.minWidth = `${reference.offsetWidth}px`;
      return () => {};
    }
  };

  static flipModifier(placements: string[] = ['right', 'bottom', 'top', 'left']): Partial<Modifier<any, any>> {
    return {
      name: 'flip',
      options: {
        fallbackPlacements: placements
      }
    };
  }

  static offsetModifier(offset: [number, number]): Partial<Modifier<any, any>> {
    return {
      name: 'offset',
      options: {
        offset
      }
    };
  }
}
